<!-- eslint-disable -->
<template>
  <div id="container" class="hfeed wpbf-page">
    <loader object="var( --e-global-color-primary)" v-if="isLoading" color1="#ffffff" color2="#999793" size="5"
      speed="2" bg="#343a40" objectbg="#999793" opacity="80" name="spinning"></loader>
    <!--START OF HEADER NAV BAR-->

    <!--END OF HEADER NAV BAR-->
    <div data-elementor-type="wp-page" data-elementor-id="3061" class="elementor elementor-3061"
      data-elementor-settings="[]">
      <div class="elementor-section-wrap">
        <!--START of BACKGROUND SLIDER-->

        <!--END of BACKGROUND SLIDER-->
        <section
          class="has_eae_slider elementor-section elementor-top-section elementor-element elementor-section-height-full elementor-section-content-middle elementor-section-stretched elementor-section-boxed elementor-section-height-default elementor-section-items-middle"
          data-particle_enable="false" data-particle-mobile-disabled="false" data-id="17739ff"
          data-element_type="section" data-settings='{"stretch_section":"section-stretched"}'>
          <div class="elementor-background-overlay"></div>
          <div class="elementor-container elementor-column-gap-no" style="margin-top: -60px">
            <div
              class="has_eae_slider elementor-column elementor-col-100 elementor-top-column elementor-element elementor-element-bca06f3"
              data-id="bca06f3" data-element_type="column">
              <div class="elementor-widget-wrap elementor-element-populated">
                <div class="elementor-element elementor-element-3369a30 elementor-widget elementor-widget-heading"
                  data-id="3369a30" data-element_type="widget" data-widget_type="heading.default">
                  <div class="elementor-widget-container">
                    <h2 class="elementor-heading-title elementor-size-default">
                      <!-- {{lang.availbleDays.theNumberOfPeople}} -->
                    </h2>
                  </div>
                  <!-- <input v-model="companionsNumber" type="number" style="width: 40vw;border-radius: 20px;" placeholder="Please enter the Number Of Companions"> -->
                </div>
                <div class="elementor-element elementor-element-3369a30 elementor-widget elementor-widget-heading"
                  data-id="3369a30" data-element_type="widget" data-widget_type="heading.default">
                  <div class="elementor-widget-container d-flex justify-content-between align-items-center flex-wrap" style="display: flex; justify-content: space-between; align-items: center; margin-bottom: 15px; padding: 0 10px;">
                    <h2 class="elementor-heading-title elementor-size-default" style="margin: 0;">
                      {{ lang.availbleDays ? lang.availbleDays.availableDays : 'Available Days' }}
                    </h2>
                    <router-link :to="'/menuOnly_' + restaurant_id" class="btn btn-sm" style="border: 1px solid #d4af37; color: #d4af37; background: rgba(0,0,0,0.4); padding: 8px 18px; border-radius: 20px; font-weight: bold; text-decoration: none; font-size: 1rem; cursor: pointer;">
                      <i class="fa fa-book-open"></i> {{ $t('menu.viewMenu') || 'View Menu' }}
                    </router-link>
                  </div>
                </div>

                <!-- ALLERGY / DIETARY NOTES SECTION -->
                <div class="allergy-card-container">
                  <div class="allergy-header">
                    <i class="fa fa-exclamation-circle" style="color: #d7b578; margin-right: 8px; margin-left: 8px;"></i>
                    <span>{{ allergyTexts.title }}</span>
                  </div>
                  <p class="allergy-subtitle">{{ allergyTexts.subtitle }}</p>
                  <div class="allergy-chips">
                    <button
                      type="button"
                      class="allergy-chip"
                      :class="{ active: selectedAllergies.length === 0 && !customAllergyNote.trim() }"
                      @click="clearAllergies()"
                    >
                      <i class="fa fa-check-circle" v-if="selectedAllergies.length === 0 && !customAllergyNote.trim()"></i>
                      {{ allergyTexts.none }}
                    </button>
                    <button
                      type="button"
                      v-for="item in allergyOptions"
                      :key="item.key"
                      class="allergy-chip"
                      :class="{ 'active-allergy': isAllergySelected(item.label) }"
                      @click="toggleAllergy(item.label)"
                    >
                      <i class="fa" :class="isAllergySelected(item.label) ? 'fa-check-square-o' : 'fa-square-o'"></i>
                      {{ item.label }}
                    </button>
                  </div>
                  <div class="allergy-input-wrap">
                    <input
                      type="text"
                      v-model="customAllergyNote"
                      class="allergy-custom-input"
                      :placeholder="allergyTexts.placeholder"
                    />
                  </div>
                </div>
                <!-- END ALLERGY / DIETARY NOTES SECTION -->

                <section
                  class="has_eae_slider elementor-section elementor-inner-section elementor-element elementor-section-full_width elementor-section-content-middle elementor-section-height-default elementor-section-height-default"
                  data-particle_enable="false" data-particle-mobile-disabled="false" data-id="b04b56b"
                  data-element_type="section">
                  <div class="elementor-background-overlay"></div>
                  <div class="elementor-container elementor-column-gap-no">
                    <div
                      class="has_eae_slider elementor-column elementor-col-100 elementor-inner-column elementor-element elementor-element-ad8b52a"
                      data-id="ad8b52a" data-element_type="column">
                      <div class="elementor-widget-wrap elementor-element-populated">
                        <div
                          class="elementor-element elementor-element-55a9b29 elementor-widget__width-auto elementor-widget elementor-widget-template"
                          data-id="55a9b29" data-element_type="widget" data-widget_type="template.default"
                          v-for="resturantAvailableDay in resturantAvailableTimes" :key="resturantAvailableDay.date">
                          <div class="elementor-widget-container">
                            <div class="elementor-template">
                              <div data-elementor-type="single-page" data-elementor-id="3169"
                                class="elementor elementor-3169 post-3061 page type-page status-publish hentry wpbf-post"
                                data-elementor-settings="[]">
                                <div class="elementor-section-wrap">
                                  <div
                                    class="has_eae_slider elementor-section elementor-top-section elementor-element elementor-element-2c5cab5 elementor-section-content-top elementor-section-boxed elementor-section-height-default elementor-section-height-default"
                                    data-particle_enable="false" data-particle-mobile-disabled="false" data-id="2c5cab5"
                                    data-element_type="section">
                                    <div class="elementor-container elementor-column-gap-no">
                                      <div
                                        class="has_eae_slider elementor-column elementor-col-100 elementor-top-column elementor-element elementor-element-6df8897"
                                        data-id="6df8897" data-element_type="column"
                                        data-settings='{"background_background":"classic"}'>
                                        <div class="elementor-widget-wrap elementor-element-populated">
                                          <section
                                            class="has_eae_slider elementor-section elementor-inner-section elementor-element elementor-element-0cc4f0f elementor-section-boxed elementor-section-height-default elementor-section-height-default"
                                            data-particle_enable="false" data-particle-mobile-disabled="false"
                                            data-id="0cc4f0f" data-element_type="section">
                                            <div>
                                              
                                              <div class="row">
                                                <div
                                                  class="has_eae_slider col-md-7 col-5 elementor-column elementor-col-50 elementor-inner-column elementor-element"
                                                  data-id="2ccde09" data-element_type="column">
                                                  <div class="elementor-widget-wrap elementor-element-populated">
                                                    <div
                                                      class="elementor-element elementor-element-567090e elementor-widget elementor-widget-heading"
                                                      data-id="567090e" data-element_type="widget"
                                                      data-widget_type="heading.default">
                                                      <div class="elementor-widget-container">
                                                        <h2 class="elementor-heading-title elementor-size-default"
                                                          style="font-size: 1.2rem;">
                                                          {{ resturantAvailableDay.day }}
                                                        </h2>

                                                      </div>
                                                    </div>
                                                  </div>
                                                </div>
                                                <div
                                                  class="has_eae_slider col-md-4 col-7 elementor-column elementor-col-50 elementor-inner-column elementor-element"
                                                  data-id="eb01e92" data-element_type="column">
                                                  <div class="elementor-widget-wrap elementor-element-populated">
                                                    <h4 class="">
                                                      {{ resturantAvailableDay.date }}
                                                    </h4>

                                                  </div>
                                                </div>

                                              </div>
                                              <div class="row">
                                                <div class="col-md-12 text-left">
                                                  <label class="available-seats mb-0">*{{$t('availbleDays.available_seats')}}</label>
                                                </div>
                                              </div>
                                              <div class="row">
                                                <div class="col-md-12">
                                                  <div
                                                    class="elementor-element elementor-element-7f63bd8 MAoptions elementor-widget elementor-widget-html"
                                                    data-id="7f63bd8" data-element_type="widget"
                                                    data-widget_type="html.default">
                                                    <div class="elementor-widget-container">
                                                      <ul style="
                                                          list-style-type: none;
                                                          margin: auto;
                                                          padding-left: 0px;
                                                          text-align: center;
                                                        ">
                                                        <li style="
                                                            display: inline-block;
                                                            margin-inline: 0.25em;
                                                          "
                                                          v-for="availableHour in resturantAvailableDay.availableHours"
                                                          :key="availableHour">
                                                          <div class="radio">
                                                            <input :id="availableHour.id" name="radio" type="radio" @click="
      setTimeAvail(
        availableHour.id,
        resturantAvailableDay.date
      )
      " />
                                                            <label :for="availableHour.id" class="radio-label p-2">
                                                              {{ availableHour.time }} <span class="available-seats">({{
      availableHour.available_seats }}) 
                                                              </span></label>
                                                          </div>
                                                        </li>
                                                      </ul>
                                                    </div>
                                                  </div>
                                                </div>
                                              </div>
                                            </div>
                                          </section>
                                          <section
                                            class="has_eae_slider elementor-section elementor-inner-section elementor-element elementor-element-52c8f58 elementor-section-boxed elementor-section-height-default elementor-section-height-default"
                                            data-particle_enable="false" data-particle-mobile-disabled="false"
                                            data-id="52c8f58" data-element_type="section">
                                            <div class="elementor-container elementor-column-gap-default">
                                              <div
                                                class="has_eae_slider elementor-column elementor-col-100 elementor-inner-column elementor-element elementor-element-fa6ec3a"
                                                data-id="fa6ec3a" data-element_type="column">
                                                <div class="elementor-widget-wrap elementor-element-populated">
                                                  <div
                                                    class="elementor-element elementor-element-6af7df8 elementor-align-justify elementor-widget elementor-widget-button"
                                                    data-id="6af7df8" data-element_type="widget"
                                                    data-widget_type="button.default">
                                                    <div class="elementor-widget-container">
                                                      <div class="elementor-button-wrapper">
                                                        <button @click="
      checkOut(
        resturantAvailableDay.date
      )
      " class="elementor-button-link elementor-button elementor-size-xs" role="button">
                                                          <span class="elementor-button-content-wrapper">
                                                            <span class="elementor-button-text">{{
      lang
        .availbleDays
        .choose
                                                              }}</span>
                                                          </span>
                                                        </button>
                                                      </div>
                                                    </div>
                                                  </div>
                                                </div>
                                              </div>
                                            </div>
                                          </section>
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </section>
              </div>
            </div>
          </div>
        </section>
      </div>
    </div>
    <div id="error-modal" class="modal">
      <div class="modal-content confirmation-modal-content">
        <div class="container">
          <h2 class="confirm-title">{{$t('confirmation.invalidMessage')}}</h2>
          <p>{{  invalidMessage }}</p>

          <div class="clearfix">
            <button type="button" class="cancelbtn" @click="cancelConfirm()">
              {{lang.confirmation.cancel }}
            </button>
          </div>
        </div>
      </div>
    </div>
    <div id="package-warning-modal" class="modal">
      <div class="modal-content confirmation-modal-content">
        <div class="container">
          <h2 class="confirm-title">{{ (lang && lang.confirmation && lang.confirmation.ConfirmationMessage) || 'Confirmation Message' }}</h2>
          <p>{{ warningMessage }}</p>
          <p v-if="lang && lang.confirmation && lang.confirmation.sueAdd"><b>{{ lang.confirmation.sueAdd }}</b></p>

          <div class="clearfix d-flex justify-content-center">
            <button type="button" class="cancelbtn" @click="cancelWarning()">
              {{ (lang && lang.confirmation && lang.confirmation.cancel) || 'Cancel' }}
            </button>
            <button type="button" class="confirmbtn" @click="confirmPackageExtraCharge()">
              {{ (lang && lang.confirmation && lang.confirmation.confirm) || 'Confirm' }}
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
const ALLERGY_DICTIONARY = {
  en: {
    title: "Food Allergies & Dietary Notes",
    subtitle: "Do you or your companions have any food allergies? Select below or type your notes:",
    none: "No Allergies",
    placeholder: "Other allergies or dietary notes (optional)...",
    options: [
      { key: "nuts", label: "Nuts / Peanuts" },
      { key: "dairy", label: "Dairy / Lactose" },
      { key: "gluten", label: "Gluten / Wheat" },
      { key: "seafood", label: "Seafood / Shellfish" },
      { key: "eggs", label: "Eggs" },
      { key: "soy", label: "Soy" },
      { key: "sesame", label: "Sesame" }
    ]
  },
  fr: {
    title: "Allergies alimentaires et notes diététiques",
    subtitle: "Avez-vous des allergies alimentaires ? Sélectionnez ci-dessous ou saisissez vos notes :",
    none: "Aucune allergie",
    placeholder: "Autres allergies ou remarques alimentaires (facultatif)...",
    options: [
      { key: "nuts", label: "Fruits à coque / Arachides" },
      { key: "dairy", label: "Produits laitiers / Lactose" },
      { key: "gluten", label: "Gluten / Blé" },
      { key: "seafood", label: "Fruits de mer / Crustacés" },
      { key: "eggs", label: "Œufs" },
      { key: "soy", label: "Soja" },
      { key: "sesame", label: "Sésame" }
    ]
  },
  it: {
    title: "Allergie alimentari e note dietetiche",
    subtitle: "Avete allergie alimentari? Selezionate qui sotto o inserite le vostre note:",
    none: "Nessuna allergia",
    placeholder: "Altre allergie o note alimentari (facoltativo)...",
    options: [
      { key: "nuts", label: "Frutta a guscio / Arachidi" },
      { key: "dairy", label: "Latticini / Lattosio" },
      { key: "gluten", label: "Glutine / Grano" },
      { key: "seafood", label: "Frutti di mare / Crostacei" },
      { key: "eggs", label: "Uova" },
      { key: "soy", label: "Soia" },
      { key: "sesame", label: "Sesamo" }
    ]
  },
  de: {
    title: "Lebensmittelallergien & Ernährungshinweise",
    subtitle: "Haben Sie Lebensmittelallergien? Bitte unten auswählen oder eingeben:",
    none: "Keine Allergien",
    placeholder: "Weitere Allergien oder Hinweise (optional)...",
    options: [
      { key: "nuts", label: "Nüsse / Erdnüsse" },
      { key: "dairy", label: "Milchprodukte / Laktose" },
      { key: "gluten", label: "Gluten / Weizen" },
      { key: "seafood", label: "Meeresfrüchte / Schalentiere" },
      { key: "eggs", label: "Eier" },
      { key: "soy", label: "Soja" },
      { key: "sesame", label: "Sesam" }
    ]
  },
  ru: {
    title: "Пищевая аллергия и диетические примечания",
    subtitle: "Есть ли у вас пищевая аллергия? Выберите ниже или введите примечание:",
    none: "Нет аллергии",
    placeholder: "Другие виды аллергии или примечания (необязательно)...",
    options: [
      { key: "nuts", label: "Орехи / Арахис" },
      { key: "dairy", label: "Молочные продукты / Лактоза" },
      { key: "gluten", label: "Глютен / Пшеница" },
      { key: "seafood", label: "Морепродукты / Моллюски" },
      { key: "eggs", label: "Яйца" },
      { key: "soy", label: "Соя" },
      { key: "sesame", label: "Кунжут" }
    ]
  },
  ar: {
    title: "حساسية الطعام والملاحظات الغذائية",
    subtitle: "هل تعاني أنت أو مرافقوك من أي حساسية طعام؟ اختر من القائمة أو اكتب ملاحظاتك:",
    none: "لا توجد حساسية",
    placeholder: "أنواع حساسية أخرى أو ملاحظات غذائية (اختياري)...",
    options: [
      { key: "nuts", label: "مكسرات / فول سوداني" },
      { key: "dairy", label: "ألبان / لاكتوز" },
      { key: "gluten", label: "غلوتين / قمح" },
      { key: "seafood", label: "مأكولات بحرية / محار" },
      { key: "eggs", label: "بيض" },
      { key: "soy", label: "صويا" },
      { key: "sesame", label: "سمسم" }
    ]
  }
};

export default {
  name: "CheckAvailableDays",
  data() {
    return {
      hotelId: 1,
      restaurant_id: this.$route.params.restId,
      orderId: this.$route.params.orderId,
      userCheckIn: "",
      resturantAvailableTimes: [],
      guestData: [],
      selectedTime: 0,
      selectedAvailable: "",
      selectedDate: "",
      companionsNumber: "",
      isLoading: false,
      lang: "",
      invalidMessage: "",
      warningMessage: "",
      selectedAllergies: [],
      customAllergyNote: ""
    };
  },
  computed: {
    currentLocale() {
      return localStorage.getItem("localization") || (this.$i18n && this.$i18n.locale) || "en";
    },
    allergyTexts() {
      return ALLERGY_DICTIONARY[this.currentLocale] || ALLERGY_DICTIONARY.en;
    },
    allergyOptions() {
      return this.allergyTexts.options;
    },
    combinedAllergies() {
      const parts = [];
      if (this.selectedAllergies.length > 0) {
        parts.push(this.selectedAllergies.join(", "));
      }
      if (this.customAllergyNote && this.customAllergyNote.trim()) {
        parts.push(this.customAllergyNote.trim());
      }
      return parts.join(" - ");
    }
  },
  created() {
    if(!User.loggedIn()){
      this.$router.push({name:'GuestLogin' });
        }
    localStorage.removeItem("currentBookingAllergies");
    this.setLang();
    // this.getUserCheckinAvail();
    this.getGuestInfo();


  },
  methods: {
    isAllergySelected(label) {
      return this.selectedAllergies.indexOf(label) !== -1;
    },
    toggleAllergy(label) {
      const idx = this.selectedAllergies.indexOf(label);
      if (idx === -1) {
        this.selectedAllergies.push(label);
      } else {
        this.selectedAllergies.splice(idx, 1);
      }
    },
    clearAllergies() {
      this.selectedAllergies = [];
      this.customAllergyNote = "";
    },
    getGuestInfo() {
      this.axios
        .get(
          process.env.VUE_APP_API_BASE_URL +
          "api/user-profile?api_key=" +
          process.env.VUE_APP_API_KEY +
          "&lang=" +
          process.env.VUE_APP_LANG +
          "&api_token=" +
          localStorage.getItem("token") +
          "&hotel_id=1&restaurant_id=1"
      )
      .then((res) => {
		  //console.log(" ----------- Guest Info ---------");
		  //console.log(res);
        this.guestData.guestName = res.data.data.first_name + ' ' + res.data.data.last_name
        this.guestData.guestRoom = res.data.data.more_data.room_number
        this.guestData.guestReservation = res.data.data.more_data.reservation
        this.guestData.guestArrivalData = res.data.data.more_data.checkin_date
        this.guestData.guestDepartureDate = res.data.data.more_data.checkout_date
		this.guestData.companions = res.data.data.more_data.companions
        this.isLoading = false;
		this.getResturantAvailTime();


        })
        .catch((error) => console.log(error));
    },
    cancelConfirm() {
      document.getElementById("error-modal").style.display = "none";
    },
    cancelWarning() {
      document.getElementById("package-warning-modal").style.display = "none";
    },
    confirmPackageExtraCharge() {
      document.getElementById("package-warning-modal").style.display = "none";
      this.checkOut(this.selectedDate, "yes");
    },
    setLang() {
      this.axios
        .get(
          process.env.VUE_APP_API_BASE_URL +
          "api/frontend-keywords?api_key=" +
          process.env.VUE_APP_API_KEY +
          "&lang=" +
          //  this.$i18n.locale
          localStorage.getItem("localization")
        )
        .then((res) => {
          //console.log(res);
          this.lang = res.data;
        })
        .catch((error) => {
          console.log(error);
        });
    },
    getUserCheckinAvail() {
      if (!User.loggedIn()) {
        localStorage.setItem("redirected", this.$route.params.menuId);
        this.$router.push({ path: "/" + "login" });
        return;
      }
      this.axios
        .get(
          process.env.VUE_APP_API_BASE_URL +
          "api/guest-available-dates?api_key=" +
          process.env.VUE_APP_API_KEY +
          "&lang=" +
          localStorage.getItem("localization") +
          "&api_token=" +
          localStorage.getItem("token")
        )
        .then((res) => {
          //console.log(res.data);
          this.userCheckIn = res.data;
        })
        .catch((error) => {
          console.log(error);
          this.isLoading = false;
        });
    },
    parseLocalMidnight(dateStr) {
      if (!dateStr) return new Date(NaN);
      const match = String(dateStr).trim().match(/^(\d{4})-(\d{1,2})-(\d{1,2})/);
      if (match) {
        return new Date(
          parseInt(match[1], 10),
          parseInt(match[2], 10) - 1,
          parseInt(match[3], 10),
          0, 0, 0, 0
        );
      }
      const d = new Date(dateStr);
      d.setHours(0, 0, 0, 0);
      return d;
    },
    adjustRestaurantTimesWithOffsets() {
      let checkinOffset = parseInt(localStorage.getItem('checkin_offset'), 10);
      if (isNaN(checkinOffset)) checkinOffset = 0;

      let checkoutOffset = parseInt(localStorage.getItem('checkout_offset'), 10);
      if (isNaN(checkoutOffset)) checkoutOffset = 0;

      let departureDate = this.parseLocalMidnight(this.guestData.guestDepartureDate);
      let arrivalDate = this.parseLocalMidnight(this.guestData.guestArrivalData);

      // Apply offsets to arrival and departure dates and normalize to local midnight (avoids DST 1-hour shifts)
      departureDate.setDate(departureDate.getDate() + checkoutOffset);
      departureDate.setHours(0, 0, 0, 0);

      arrivalDate.setDate(arrivalDate.getDate() + checkinOffset);
      arrivalDate.setHours(0, 0, 0, 0);

      let todayDate = new Date();
      todayDate.setHours(0, 0, 0, 0);

      // Adjust arrivalDate if it's before today
      if (arrivalDate < todayDate) {
        arrivalDate = todayDate;
      }

      // Filter and adjust the available times based on arrival and departure dates
      this.resturantAvailableTimes = this.resturantAvailableTimes.filter((time) => {
        let availableDate = this.parseLocalMidnight(time.date);
        return availableDate.getTime() >= arrivalDate.getTime() && availableDate.getTime() <= departureDate.getTime();
      });
    },
    getResturantAvailTime() {
      this.axios
        .get(
          process.env.VUE_APP_API_BASE_URL +
          "api/restaurant-available-times?api_key=" +
          process.env.VUE_APP_API_KEY +
          "&lang=" +
          localStorage.getItem("localization") +
          //process.env.VUE_APP_LANG +
          "&api_token=" +
          localStorage.getItem("token") +
          "&restaurant_id=" +
          this.restaurant_id
        )
        .then((res) => {
          console.log(res.data);
          this.resturantAvailableTimes = res.data;
        // Call the helper function to adjust times based on checkin/checkout offsets
          this.adjustRestaurantTimesWithOffsets();
          this.sortedItems();
        })
        .catch((error) => {
          console.log(error);
          this.isLoading = false;
        });
    },
    sortedItems: function () {
      this.resturantAvailableTimes.sort((a, b) => {
        return new Date(a.date) - new Date(b.date);
      });
      return this.items;
    },
    setTimeAvail(time, date) {
      this.selectedTime = time;
      this.selectedDate = date;
      //console.log(this.selectedTime);
      //console.log(this.selectedDate);
    },
    checkOut(date, extraChargeConfirmed = "no") {
      if (this.selectedDate == date) {
        // if (this.selectedDate == date && this.companionsNumber!="") {
        this.isLoading = true;

        const allergiesPayload = this.combinedAllergies;
        if (allergiesPayload) {
          localStorage.setItem("currentBookingAllergies", allergiesPayload);
        } else {
          localStorage.removeItem("currentBookingAllergies");
        }

        var formData = {
          api_key: process.env.VUE_APP_API_KEY,
          //lang: process.env.VUE_APP_LANG,
          lang: localStorage.getItem("localization"),
          api_token: localStorage.getItem("token"),
          date: this.selectedDate,
          restaurant: this.restaurant_id,
          available_time_id: this.selectedTime,
          number_of_companions: this.guestData.companions,
          allergies: allergiesPayload,
          confirmExtraCharge: extraChargeConfirmed
        };

        this.axios
          .post(
            process.env.VUE_APP_API_BASE_URL + "api/restaurant-booking-setDate",
            formData
          )
          .then((res) => {
            this.isLoading = false;
            //console.log(res.data);
            if (res.data.status == "ERROR") {
              this.invalidMessage = res.data.message
              document.getElementById("error-modal").style.display = "block";
              // alert(res.data.message);
              // this.$notify({
              //   group: "foo",
              //   title: "Invalid",
              //   text: res.data.message,
              //   type: "error",
              // });
            } else if (res.data.status == "WORNING") {
              this.warningMessage = res.data.message;
              document.getElementById("package-warning-modal").style.display = "block";
            } else {
              // this.$notify({
              //           group: "foo",
              //           title: res.data.message,
              //           text: res.data.message,
              //           type: "success",
              //         });
              let bookingID = res.data.booking_id;
              localStorage.setItem('currentBookingID', bookingID);

              if (res.data.reservation_type === 'seat_only' && res.data.order_id) {
                this.$router.push({
                  path: '/qr-print/order_' + res.data.order_id
                });
              } else {
                this.$router.push({
                  path: '/menu_' + this.restaurant_id,
                  menuId: this.restaurant_id
                });
              }
            }
          })
          .catch((error) => {
            this.isLoading = false;

            this.errors = error;
            this.invalidMessage = error
            document.getElementById("error-modal").style.display = "block";

            // this.$notify({
            //   group: "foo",
            //   title: "Invalid",
            //   text: "Something error in add to cart please check your inputs and try again ",
            //   type: "error",
            // });
            console.log(error);
          });
      } else {
        this.invalidMessage = "please check your data "
        document.getElementById("error-modal").style.display = "block";
        // this.$notify({
        //   group: "foo",
        //   title: "Invalid",
        //   text: "please check your data ",
        //   type: "error",
        // });
      }
    },
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.confirmation-modal-content {
  width: 50% !important;
}
.allergy-card-container {
  background: rgba(20, 20, 20, 0.88);
  border: 1px solid rgba(215, 181, 120, 0.55);
  border-radius: 12px;
  padding: 16px 20px;
  margin: 0 10px 22px 10px;
  color: #ffffff;
  box-shadow: 0 4px 15px rgba(0, 0, 0, 0.35);
}
.allergy-header {
  font-size: 1.15rem;
  font-weight: 700;
  color: #d7b578;
  margin-bottom: 4px;
  display: flex;
  align-items: center;
}
.allergy-subtitle {
  font-size: 0.92rem;
  color: #dcdcdc;
  margin-bottom: 12px;
}
.allergy-chips {
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
  margin-bottom: 12px;
}
.allergy-chip {
  background: rgba(255, 255, 255, 0.1);
  border: 1px solid rgba(255, 255, 255, 0.25);
  color: #ffffff;
  border-radius: 22px;
  padding: 7px 15px;
  font-size: 0.9rem;
  cursor: pointer;
  transition: all 0.2s ease;
  display: inline-flex;
  align-items: center;
  gap: 6px;
}
.allergy-chip.active {
  background: #28a745;
  border-color: #28a745;
  color: #ffffff;
  font-weight: 600;
}
.allergy-chip.active-allergy {
  background: #dc3545;
  border-color: #ff6b81;
  color: #ffffff;
  font-weight: 600;
}
.allergy-custom-input {
  width: 100%;
  background: rgba(255, 255, 255, 0.95);
  color: #222222;
  border: 1px solid #d7b578;
  border-radius: 8px;
  padding: 9px 14px;
  font-size: 0.95rem;
}
@media(max-width:767px) {
  .confirmation-modal-content {
    width: 95% !important;
  }
}
</style>
<!-- eslint-enable -->
